export const MENU_GROUP = {
  membership: 'membership',
  value: 'value',
  news: 'news',
  interactive: 'interactive',
} as const;
